<template>
    <el-dialog :visible.sync="dialogFormVisible" width="90%" append-to-body
               :close-on-click-modal="false" @close="handleClose">
        <div slot="title" class="">#{{single.id}}){{single.subject}}</div>
        <div class="">
            <div v-for="x in single.items" :key="x.id">
                <b>{{x.order}}) {{x.question}}</b>
                <div v-if="x.answer_type == 1" class="">
                    <div v-for="a in toArray(x.answers)" :key="a" style="display: inline-block;padding: 5px 20px;">
                        <label><input type="checkbox" :name="'question_'+x.id"/> {{a}}</label>
                    </div>
                </div>
                <div v-else class="">
                    <div v-for="a in toArray(x.answers)" :key="a" style="display: inline-block;padding: 5px 20px;">
                        <label>
                            <input type="radio" :name="'question_'+x.id"/> {{a}}
                        </label>
                    </div>
                </div>
                <div class="mb-3"></div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer d-flex justify-content-between align-items-center">
            <div style="flex:1;text-align: left;display: flex" class="justify-content-between align-items-baseline">
                <el-checkbox v-model="assign_mode" label="清除原有投票后再添加"  v-if="show_meeting" true-label="1" false-label="0"></el-checkbox>
                <el-select v-model="select_meeting" clearable class="ml-3 w-100" placeholder="请输入关键字查询,选择需要添加到的会议"  v-if="show_meeting"
                           filterable
                           remote
                           :remote-method="remoteMethod"
                           :loading="process.loading">
                    <el-option v-for="x in meetings" :key="x.id" :value="x.id" :label="x.label"></el-option>
                </el-select>
            </div>
            <div style="flex:0 0 250px">
                <el-button type="default" @click="handleAssign" v-if="show_meeting">添加至会议</el-button>
                <el-button type="primary" @click="dialogFormVisible=false">关 闭</el-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>

    import PollReviewMixin from "../common/mixins/poll-review-mixin"
    export default {
        name: "poll-review",
        data() {
            return {
            }
        },
        mixins:[PollReviewMixin],
    }
</script>

<style lang="scss" scoped>


</style>
